import {
  SUBJECT_CONFIG,
  getAvailableStreamsForSubject,
  getStreamConfig,
  type LearningEpisodeStream,
  type SubjectCode,
} from '../utils/subjectConfig';
import {
  findDailyReviewProgressEntry,
  resolveStreamDailyBadge,
  type DailyReviewProgress,
} from '../services/reviewService';
import { PendingCountBadge } from './PendingCountBadge';

type ReviewStreamTabsProps = {
  subject: SubjectCode;
  stream: LearningEpisodeStream;
  onStreamChange: (stream: LearningEpisodeStream) => void;
  dailyReviewProgress?: DailyReviewProgress | null;
};

export function ReviewStreamTabs({
  subject,
  stream,
  onStreamChange,
  dailyReviewProgress = null,
}: ReviewStreamTabsProps) {
  const streams = getAvailableStreamsForSubject(subject);
  const accentColor = SUBJECT_CONFIG[subject].color;

  return (
    <div className="flex gap-1 overflow-x-auto border-b border-border pb-px">
      {streams.map((entry) => {
        const isActive = entry === stream;
        const streamConfig = getStreamConfig(entry);
        const isEnabled = streamConfig?.active ?? false;
        const badge = resolveStreamDailyBadge(findDailyReviewProgressEntry(dailyReviewProgress, subject, entry));

        return (
          <button
            key={entry}
            type="button"
            disabled={!isEnabled}
            onClick={() => {
              if (isEnabled) {
                onStreamChange(entry);
              }
            }}
            className={`inline-flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2 text-sm transition ${
              isActive ? 'font-semibold' : 'border-transparent text-muted'
            } ${!isEnabled ? 'cursor-not-allowed opacity-45' : 'hover:text-ink'}`}
            style={isActive ? { borderBottomColor: accentColor, color: accentColor } : undefined}
          >
            <span>{streamConfig?.label || entry}</span>
            {isEnabled && badge.visible ? (
              <PendingCountBadge
                count={badge.count}
                tone={badge.tone}
                size="sm"
                showWhenZero={badge.tone === 'complete'}
              />
            ) : null}
            {!isEnabled ? (
              <span className="rounded-full bg-canvas px-1.5 py-0.5 text-[10px] text-subtle">即将推出</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
